<template>
  <v-navigation-drawer app v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp">
    <v-list nav rounded>
      <v-list-item-group color="accent">
        <template v-for="item in items">
          <v-divider :key="item.ref" v-if="item.divider"></v-divider>

          <v-list-item
          v-else
          :key="item.ref"
          :value="item.ref"
          @click="didTapItem(item.ref)"
          >
            <v-list-item-action class="test">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

export default {
  computed: {
    drawer: {
      get() {
        return this.$props.showDrawer;
      },
      set(v) {
        this.$emit('drawerChanged', v);
      },
    },
  },
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    didTapItem(ref) {
      if (ref === 'book') {
        window.open('https://drive.google.com/file/d/1jca15R6G-fzLUecnTF6hPDDiVHKtzPGH/view?usp=sharing');
      } else if (ref === 'videos') {
        window.open('https://www.youtube.com/channel/UCRzazidHFZXDg-GFfNkDOkg/playlists');
      } else {
        this.$router.push(ref);
      }
    },
  },
  data: () => ({
    items: [
      { icon: 'get_app', text: 'Baixar Livro', ref: 'book' },
      { icon: 'home', text: 'Introdução', ref: '/introducao' },
      { icon: 'school', text: 'Atlas', ref: '/atlas' },
      { icon: 'assignment_ind', text: 'Exames', ref: '/exames' },
      { icon: 'play_circle_fill', text: 'Vídeos', ref: 'videos' },
      { divider: true },
      { icon: 'edit', text: 'Exercícios', ref: '/exercicios' },
      { icon: 'insert_drive_file', text: 'Resumos', ref: '/resumos' },
      { divider: true },
      { icon: 'chat', text: 'Contato', ref: '/contato' },
    ],
  }),
};
</script>
